
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';

const ModalExcluirSocio = (props) => {

    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        if (loading) return;
        props.onClose();
    };

    const handleAgree = async () => {
        setLoading(true);
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/excluirSocio/${props.socio.idSocio}`, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            });
            if (response.data.status === 200) {
                props.onSuccess('Sócio excluído com sucesso!');
            } else {
                props.onError(response.data.mensagem || 'Erro ao excluir sócio. Tente novamente.');
            }
        } catch (error) {
            props.onError(error.response?.data?.mensagem || 'Erro ao excluir sócio. Tente novamente.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={handleClose}
                aria-labelledby="excluir-socio-title"
                aria-describedby="excluir-socio-description"
            >
                <DialogTitle id="excluir-socio-title">
                    {"Deseja realmente excluir este sócio?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="excluir-socio-description">
                        {props.socio?.nome ? <><strong>{props.socio.nome}</strong> será removido da ficha cadastral junto com os documentos enviados. </> : null}
                        Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
                    <Button onClick={handleClose} disabled={loading} variant='contained' color='success' size='small'>Manter Sócio</Button>
                    <Button onClick={handleAgree} loading={loading} autoFocus color='error' size='small'>Excluir Sócio</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalExcluirSocio;
